import { render } from "./parent-graph.vue?vue&type=template&id=4c8ae35d&scoped=true&lang=true"
import script from "./parent-graph.vue?vue&type=script&lang=js"
export * from "./parent-graph.vue?vue&type=script&lang=js"

import "./parent-graph.vue?vue&type=style&index=0&id=4c8ae35d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8ae35d"]])

export default __exports__